<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-wellbean-login></app-wellbean-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-wellbean-register></app-wellbean-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-wellbean-forgot-password></app-wellbean-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-wellbean-change-password-sent></app-wellbean-change-password-sent>
  </div>

  <app-wellbean-register-resend
    *ngIf="page === 'register-resend'"
  ></app-wellbean-register-resend>
</ng-container>
